import { MCPermissions } from "~/common/constants";
import { requiresPlusPermissions } from "~/components/AssetDownload/assetDownloadHelpers";
import { ReportPreviewTemplateIds } from "~/components/Piano/piano-types";
import { commonConfig } from "~/config/common-config";

type TemplateValues = {
  sandbox: { templateId: string; templateVariantId?: string };
  prod: { templateId: string; templateVariantId?: string };
};

const premiumDataTemplates: TemplateValues = {
  prod: { templateId: "OTIZND52RYAT", templateVariantId: "OTVZQTGI8J87M" },
  sandbox: { templateId: "OTOWFQ3VHZVG", templateVariantId: "OTVKG3OIF934D" },
};

export const getPremiumAssetPaywallIds = (
  environment: typeof commonConfig.NEXT_PUBLIC_ENDIL_ENV = commonConfig.NEXT_PUBLIC_ENDIL_ENV
) =>
  environment === "production"
    ? premiumDataTemplates.prod
    : premiumDataTemplates.sandbox;

export const getPianoTemplateIds = (
  environment: typeof commonConfig.NEXT_PUBLIC_ENDIL_ENV
) => getPremiumAssetPaywallIds(environment);

const REPORT_PREVIEW_TEMPLATE_FALLBACK = "OT2MP2H9DNFQ";

export const getReportTemplateIds = (
  templateIds: ReportPreviewTemplateIds | null | undefined,
  requiredPermissions: MCPermissions[]
): {
  templateId: string;
  templateVariantId?: string;
} => {
  if (templateIds && requiredPermissions.includes(MCPermissions.PRO_PERM)) {
    return {
      templateId: templateIds.RegisteredReportTemplateId,
      templateVariantId: templateIds.RegisteredReportVariantId,
    };
  }

  if (
    templateIds &&
    requiredPermissions.includes(MCPermissions.PRO_FULL_ACCESS_PERM)
  ) {
    return {
      templateId: templateIds.ProReportTemplateId,
      templateVariantId: templateIds.ProReportVariantId,
    };
  }

  if (templateIds && requiresPlusPermissions(requiredPermissions)) {
    return {
      templateId: templateIds.ProPlusReportTemplateId,
      templateVariantId: templateIds.ProPlusReportVariantId,
    };
  }

  return {
    templateId: REPORT_PREVIEW_TEMPLATE_FALLBACK,
    templateVariantId: undefined,
  };
};
